import Icon from './components/Icon';

export function PreviousPageIcon() {
  return <Icon id="paginator-previous-chevron" viewBox="0 0 20 21" />;
}

export function NextPageIcon() {
  return <Icon id="paginator-next-chevron" viewBox="0 0 20 21" />;
}
